/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {STRICT_WIDTH_CLASS} from './constants';
import {DatagridRenderOrganizer} from './render-organizer';
export class DatagridCellRenderer implements OnDestroy {
/**
 * @param {?} el
 * @param {?} renderer
 * @param {?} organizer
 */
constructor(private el: ElementRef,
private renderer: Renderer2, organizer: DatagridRenderOrganizer) {
        this.subscription = organizer.clearWidths.subscribe(() => this.clearWidth());
    }
private subscription: Subscription;
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }
/**
 * @return {?}
 */
private clearWidth() {
        this.renderer.removeClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        this.renderer.setStyle(this.el.nativeElement, "width", null);
    }
/**
 * @param {?} strict
 * @param {?} value
 * @return {?}
 */
public setWidth(strict: boolean, value: number) {
        if (strict) {
            this.renderer.addClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        } else {
            this.renderer.removeClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        }
        this.renderer.setStyle(this.el.nativeElement, "width", value + "px");
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-dg-cell"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: DatagridRenderOrganizer, },
];
}

function DatagridCellRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridCellRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridCellRenderer.ctorParameters;
/** @type {?} */
DatagridCellRenderer.prototype.subscription;
/** @type {?} */
DatagridCellRenderer.prototype.el;
/** @type {?} */
DatagridCellRenderer.prototype.renderer;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
